import { render, staticRenderFns } from "./server.vue?vue&type=template&id=a24ee9da&scoped=true"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"
import style0 from "./server.vue?vue&type=style&index=0&id=a24ee9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24ee9da",
  null
  
)

export default component.exports